<template>
  <div class="orderWraper">
      <div class="type">
        <div class="item" @click="choseType(3)" :class="{active: type == 3}">全部</div>
        <div class="item" @click="choseType(2)" :class="{active: type == 2}" >已{{orderType}} </div>
        <div class="item" @click="choseType(1)" :class="{active: type == 1}">未{{orderType}}</div> 
      </div>
      <div class="table">
        <div class="th">
          <div class="td" style="width: 25%">村庄名称</div>
          <div class="td" style="width: 25%">姓名</div>
          <div class="td" style="width: 35%">电话</div>
          <div class="td" style="width: 15%">状态</div>
        </div> 
      </div>
      <div class="table tbodyWraper">            
          <div class="tbody" :style="'transform: translateY(' + top + 'px)'">
            <div class="tr" v-for="(item, i) in order" :key="i">
              <div class="td" style="width: 25%">{{item.aname}}</div>
              <div class="td" style="width: 25%">{{item.name}}</div>
              <div class="td" style="width: 35%">{{item.phone}}</div>
              <div class="td active" style="width: 15%" v-if="item.status == 2 || item.status == 3">已{{orderType}}</div>
              <div class="td active" style="width: 15%" v-if="item.status == 1 || item.status == 0">未{{orderType}}</div>
            </div>   
          </div>                         
      </div>     
  </div>
</template>

<script>
export default {
  props: ['orderType', 'order'],
  data() {
    return {
      type: 3,
      top: 0,    
      timer: ''  
    }
  },
  methods: {        
    choseType(type) {
      this.type = type;
      this.$emit('typeChange', type);
    },
  },
  mounted() {
    let wraperHeight = document.getElementsByClassName('tbodyWraper')[0].clientHeight;    
    const height = 35;
    let showLines = Math.ceil(wraperHeight / height);
    // eslint-disable-next-line no-console
    console.log(showLines)
    let i = 0;
    if(this.order.length > showLines) {   
      this.timer = setInterval(() => {
        i ++;
        this.top = 0 - i * height;
        if(i >= 10 - showLines) {
          i = 0;
        }
      }, 2500)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style>
.orderWraper {
  height: calc(100% - 50px);
}
.orderWraper .tbodyWraper{
  height: calc(100% - 72px);
  overflow: hidden;
}
.orderWraper .tbody {
  transition: all .5s;
  /* height: calc(100% - 35px); */
  /* overflow: hidden; */
}
</style>